import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DisputesActions from "./../../../store/actions/Disputes";
import Details from "../../../components/Disputes/Details";
import TopActionBar from "../../../components/Disputes/TopActionBar";
import { getPath, isValNull } from "../../../utils";

const DisputeDetails = ({
    getDisputeDetails,
    DisputeDetails,
    allMenuActions,
    resetDisputeDetails,
}) => {
    const { id } = useParams();
    const loadDispute = (id) => {
        var filter = {
                dispute_id: id
        }
        resetDisputeDetails();
        getDisputeDetails(filter);
    };
    useEffect(() => {
        if (!(DisputeDetails.find(d => d.id === id)) || !DisputeDetails) {
            loadDispute(id);
        }
    }, [id]);

    return (
        <div>
            <TopActionBar
                id={id}
                allMenuActions={allMenuActions}
                refresh={loadDispute}
            />
            <Details details={DisputeDetails} />
        </div>
    );
};

function mapStateToProps(state) {
    const { Disputes } = state;
    return {
        DisputeDetails: Disputes.Dispute,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDisputeDetails: bindActionCreators(
            DisputesActions.getDisputeDetails,
            dispatch
        ),
        resetDisputeDetails: bindActionCreators(
            DisputesActions.resetDisputesDetails,
            dispatch
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DisputeDetails);
